import realpressImportDemo from './setup/import-demo';
import realpressSetupPages from './setup/pages';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressImportDemo();
	realpressSetupPages();
} );
